var team20 = [
    [
        {
           
        },
        {
            
        },
    ],

    [
    {
        name: "Ankit Verma",
        post: "Coordinator",
        fb: "https://www.facebook.com/profile.php?id=100009646039570",
        insta: "https://www.instagram.com/ankit_verma101/",
        linkedin: "https://www.linkedin.com/in/ankit-kumar-40a1981a8/",
        mail: "ankitver@iitk.ac.in",
        image: "team20/ankit.jpg"
    },
    {
        name: "Mradul Chaudhary",
        post: "Coordinator",
        fb: "https://facebook.com/mradul.chaudhary.161",
        insta: "https://www.instagram.com/mradul.chaudhary.1105/?hl=en",
        linkedin: "https://www.linkedin.com/in/mradul-chaudhary",
        mail: "mradulch@iitk.ac.in",
        image: "team20/mradul.jpg"
    },
    {
        name: "Yashkrit Gupta",
        post: "Coordinator",
        fb: "https://www.facebook.com/yashkrit.gupta/",
        insta: "https://instagram.com/yashkrit_gupta?igshid=mm6wh2hwimx8",
        linkedin: "https://www.linkedin.com/in/yashkrit-gupta-8503a3145",
        mail: "mailto:yashkrit@iitk.ac.in",
        image: "team20/yashkrit.jpeg"
    },
],
[
    {
        name: "Harsh Kumar Gautam",
        post: "Secretary, Events",
        fb: "https://www.facebook.com/harsh.gautam.7370",
        insta: "https://www.instagram.com/invites/contact/?i=t0w0pwliqhqv&utm_content=2iiwccr",
        linkedin: "",
        mail: "mailto:kaushalkj20@iitk.ac.in",
        image: "team20/harsh.jpg"
    },
    {
        name: "Nidhi Kansal",
        post: "Secretary, Events",
        fb: "https://www.facebook.com/nidhi.kansal.2412",
        insta: "https://www.instagram.com/_nidhi_kansal/",
        linkedin: "https://www.linkedin.com/in/nidhi-kansal-70978a20b/",
        mail: "mailto:nidhik@iitk.ac.in",
        image: "team20/nidhi.jpg"
    },
    {
        name: "Navshruti Singh",
        post: "Secretary, Events",
        fb: "https://www.facebook.com/navshruti.singh.52",
        insta: "https://www.instagram.com/_navshruti_singh_",
        linkedin: "",
        mail: "nshruti@iitk.ac.in",
        image: "team20/navshruti.jpg"
    },
    {
        name: "Raj Karan Kumar",
        post: "Secretary, Events",
        fb: "https://www.facebook.com/profile.php?id=100038130162045",
        insta: "https://www.instagram.com/raj_karan_3081/",
        linkedin: "",
        mail: "mailto:rajkaran@iitk.ac.in",
        image: "team20/raj.jpg"
    },
    {
        name: "Rishabh Arora",
        post: "Secretary, Event",
        fb: "https://m.facebook.com/rishabh.arora.16752754",
        insta: "https://www.instagram.com/rishabh.ar0ra/",
        linkedin: "https://www.linkedin.com/in/rishabh-arora-8b2124199",
        mail: "mailto:risharo@iitk.ac.in",
        image: "team20/rishabh.jpg"
    },
    {
        name: "Sonam Meena",
        post: "Secretary, Events",
        fb: "https://www.facebook.com/sonam.meena.14606936",
        insta: "https://www.instagram.com/sonamjorwal_02/?hl=en",
        linkedin: "https://www.linkedin.com/in/sonam-meena-7354091b7",
        mail: "mailto:sonamm@iitk.ac.in",
        image: "team20/sonam.jpeg"
    },
    {
        name: "Yash Laddha",
        post: "Secretary, Events",
        fb: "https://www.facebook.com/yash.laddha.1217",
        insta: "https://www.instagram.com/invites/contact/?i=z1pupthh439q&utm_content=f4t4hii",
        linkedin: "",
        mail: "mailto:yladdha@iitk.ac.in",
        image: "team20/yash.jpg"
    },
    {
        name: "Janhavi Bhoge",
        post: "Secretary, Content",
        fb: "https://www.facebook.com/janhavi.bhoge.5",
        insta: "https://www.instagram.com/janhavinainamohanbhoge/",
        linkedin: "https://www.linkedin.com/in/janhavi-b-38b8801b2",
        mail: "mailto:janhavim@iitk.ac.in",
        image: "team20/jahnvi.jpg"
    },
    {
        name: "Rohit Sharma",
        post: "Secretary, Content",
        fb: "https://www.facebook.com/profile.php?id=100003925016375",
        insta: "https://www.instagram.com/nil",
        linkedin: "https://linkedin.com/nil",
        mail: "mailto:rohitsh@iitk.ac.i",
        image: "team20/rohit.jpg"
    },
    {
        name: "Nitin Patil",
        post: "Secretary, Design",
        fb: "https://www.facebook.com/profile.php?id=100003897020422",
        insta: "https://instagram.com/nitin11041?igshid=avjp1ayg4xxv",
        linkedin: "https://www.linkedin.com/in/nitin-patil-b7869b1aa",
        mail: "mailto:nitinp@iitk.ac.in",
        image: "team20/nitin.jpg"
    },
    {
        name: "Shreya Vaish",
        post: "Secretary, Design",
        fb: "https://www.facebook.com/profile.php?id=100000947592369",
        insta: "https://www.instagram.com/rantcat__vaish/",
        linkedin: "https://www.linkedin.com/in/shreya-vaish-4694491b0/",
        mail: "mailto:vaishrey@iitk.ac.in",
        image: "team20/shreya.png"
    },
   
    {
        name: "Aryan Agarwal",
        post: "Secretary, Web",
        fb: "https://www.facebook.com/aryan.agarwal.969952",
        insta: "https://www.instagram.com/aryann_ag/",
        linkedin: "https://www.linkedin.com/in/aryan-agarwal-6480771b6",
        mail: "mailto:aryanag@iitk.ac.in",
        image: "team20/aryan.jpg"
    },
    {
        name: "Devansh Jain",
        post: "Secretary, Web",
        fb: "https://www.facebook.com/devansh.jain.5817",
        insta: "https://instagram.com/devansh_jain2013?igshid=la8trokivu3l",
        linkedin: "https://www.linkedin.com/in/devansh-jain-1987bb1b2",
        mail: "mailto:devanshj@iitk.ac.in",
        image: "team20/devansh.jpg"
    },
    {
        name: "Govind Gupta",
        post: "Secretary, Web",
        fb: "https://www.facebook.com/profile.php?id=100005799362676",
        insta: "https://www.instagram.com/thlegend_of_artist/?hl=en",
        linkedin: "https://www.linkedin.com/in/govind-gupta-b96b1b197/",
        mail: "mailto:govindg@iitk.ac.in",
        image: "team20/Govind.jpeg"
    },
    {
        name: "Hitesh Kumar",
        post: "Secretary, Web",
        fb: "https://www.facebook.com/hitesh.bijarniya.58",
        insta: "https://www.instagram.com/nil",
        linkedin: "https://linkedin.com/nil",
        mail: "mailto:hitesh@iitk.ac.in",
        image: "team20/hitesh.jpg"
    },
    {
        name: "Rohan Kumar",
        post: "Secretary, Web",
        fb: "https://www.facebook.com/rohankj01/",
        insta: "https://www.instagram.com/rohankj01/",
        linkedin: "https://www.linkedin.com/in/rohankj01/",
        mail: "mailto:rohankj@iitk.ac.in",
        image: "team20/rohan.jpg"
    },
    {
        name: "Saral Verma",
        post: "Secretary, Web",
        fb: "https://www.facebook.com/saral.verma.330/",
        insta: "https://www.instagram.com/its.easy.here/?hl=en",
        linkedin: "https://www.linkedin.com/in/saral-verma-3b2b041b0/",
        mail: "mailto:svsaral@iitk.ac.in",
        image: "team20/saral.jpg"
    },
]
]

module.exports = team20;
